<template>
  <router-view/>
</template>

<script>
  export default {
    name: 'list'
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// List.vue?310bb99e